import React, { memo, useRef, useState } from 'react';
import classNames from 'classnames';
import { ClickAwayListener } from '@material-ui/core';

import Clickable from 'common/Clickable';

import isFunction from 'utils/isFunction';

import './CountrySelectBox.scss';

const CountrySelectBox = ({
  label,
  hasFocus = false,
  name,
  disabled = false,
  options = [],
  onSelect,
  value,
  className,
  render,
}) => {
  const [opened, setOpened] = useState(hasFocus);

  const containerClasses = classNames('CountrySelectBox', className);
  const labelClasses = classNames('label', { 'label--opened': opened });

  const boxRef = useRef(null);

  const handleChange = (option) => (e) => {
    setOpened(false);
    onSelect({ target: { ...e, ...option, name } });
  };

  const handleMenuToggle = () => {
    setOpened((o) => !o);
  };

  return (
    <div className={containerClasses}>
      <h4 className={labelClasses}>{label}</h4>
      <Clickable
        type="div"
        ref={boxRef}
        disabled={disabled}
        className="selectBox"
        onClick={handleMenuToggle}
      >
        {value}
      </Clickable>
      {opened && (
        <ClickAwayListener onClickAway={handleMenuToggle}>
          <div className="selectBox__menuContainer">
            <div className="selectBox__menu">
              {options &&
                options.map((option) => (
                  <Clickable
                    key={option?.id}
                    className="selectBox__menuItem"
                    onClick={handleChange(option)}
                  >
                    {isFunction(render) ? render(option) : option?.text}
                  </Clickable>
                ))}
            </div>
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
};

export default memo(CountrySelectBox);
